const formatToISODate = (dateInput) => {
    if (!dateInput || dateInput === "0000-00-00") {
      return "";
    }
  
    const date = new Date(dateInput);
    if (isNaN(date)) {
      return "";
    }
  
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // mois de 01 à 12
    const day = String(date.getDate()).padStart(2, "0"); // jour de 01 à 31
  
    return `${year}-${month}-${day}`;
  };
  
  export default formatToISODate;
  